const config = {
  protocol: "https",
  api_method: "https",
  api_version: "v1"
};

switch (process.env.NODE_ENV) {
  case "development":
    config.protocol = "http";
    config.api_method = "http";
    config.api_server = "192.168.33.10:3000";
    config.kintai = {
      protocol: "http",
      server: "localhost:8070"
    };
    break;
  // case "staging":
  //   config.protocol = "https";
  //   config.api_method = "https";
  //   // TODO: ステージングのAPI用URL
  //   config.api_server = "staging-api.yokasystem.info";
  //   break;
  case "production":
    config.protocol = "https";
    config.api_method = "https";
    config.api_server = "api.yokasystem.info";
    config.kintai = {
      protocol: "https",
      server: "f.yokasystem.info"
    };
    break;
}

export default config;
